import { Box, Chip, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { TranslateText } from '../../../../../../../../../application/language/TranslateText';
import { IUnitCardModel } from '../../../../interface/IUnitCardModel';
import { IUnitListAdminPageDomain } from '../../../../learningUnitList/store/IUnitListAdminPageDomain';
import { RecommendedUnitListItem } from '../RecommendedUnitListItem';

interface Props {
  title: string;
  units: IUnitCardModel[];
  domain: IUnitListAdminPageDomain;
  checkedUnits?: string[];
  currentRoleId?: string | null;
  setCheckedUnits?: (value: any) => any;
}

export const RecommendedUnitListCard = observer(
  ({ title, units, domain, currentRoleId, checkedUnits, setCheckedUnits }: Props) => {
    const requiredUnits = units.filter(
      (item) =>
        currentRoleId &&
        Array.isArray(item.settings?.teamRolesIds) &&
        item.settings.teamRolesIds.includes(currentRoleId) &&
        item.isPublished,
    );

    const optionalUnits = units.filter((item) =>
      currentRoleId
        ? Array.isArray(item.settings?.teamRolesIds) &&
          !item.settings.teamRolesIds.includes(currentRoleId) &&
          item.isPublished
        : item.isPublished,
    );

    const handleCheck = (id: string) => {
      setCheckedUnits?.((prev: string[]) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
    };

    if (!requiredUnits.length && !optionalUnits.length) return null;

    return (
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: 'repeat(auto-fill,64px)',
          rowGap: '8px',
        }}
      >
        <Typography variant="h6">{title}</Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {requiredUnits.length > 0 && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', opacity: 0.5 }}>
                <div>
                  <TranslateText i18nKey="phrases.mandatory" />
                </div>
                <Chip label={requiredUnits.length} variant="outlined" />
              </Box>
              {requiredUnits.map((item) => (
                <RecommendedUnitListItem
                  key={item.id}
                  handleEdit={domain.onEditUnit}
                  handleDelete={domain.onDeleteUnit}
                  handlePublish={domain.publishUnit}
                  handleUnpublish={domain.unpublishUnit}
                  card={{
                    name: item.settings?.titleHeading,
                    isPublished: item.isPublished,
                    id: item.id,
                    image: item.settings?.preview?.data || '',
                  }}
                  isChecked={checkedUnits?.includes(item.id)}
                  handleCheck={() => handleCheck(item.id)}
                />
              ))}
            </>
          )}

          {optionalUnits.length > 0 && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', opacity: 0.5 }}>
                <div>
                  <TranslateText i18nKey="phrases.optional" />
                </div>
                <Chip label={optionalUnits.length} variant="outlined" />
              </Box>
              {optionalUnits.map((item) => (
                <RecommendedUnitListItem
                  key={item.id}
                  handleEdit={domain.onEditUnit}
                  handleDelete={domain.onDeleteUnit}
                  handlePublish={domain.publishUnit}
                  handleUnpublish={domain.unpublishUnit}
                  card={{
                    name: item.settings?.titleHeading,
                    isPublished: item.isPublished,
                    id: item.id,
                    image: item.settings?.preview?.data || '',
                  }}
                  isChecked={checkedUnits?.includes(item.id)}
                  handleCheck={() => handleCheck(item.id)}
                />
              ))}
            </>
          )}
        </Box>
      </Box>
    );
  },
);
